export const AnalyticServiceTypeKeys = {
	prepaid: 'Prepaid',
	postpaid: 'Postpaid',
	tv: 'TV',
	msat: 'mSAT TV',
	tel: 'TEL',
	combine: 'Kombinuj',
	dopuna: 'DopunaNET',
	net: 'NET',
};
